import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTrackTime = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "track-time" }), /* @__PURE__ */ _jsx("path", { d: "M16 31.714c-8.819 0-16-7.181-16-16s7.181-16 16-16c8.819 0 16 7.181 16 16s-7.181 16-16 16zM16 2.274c-7.411 0-13.44 6.029-13.44 13.44s6.029 13.44 13.44 13.44c7.411 0 13.44-6.029 13.44-13.44s-6.029-13.44-13.44-13.44zM24.319 17.634h-8.845c-0.704 0-1.28-0.576-1.28-1.28v-8.96c0-0.704 0.576-1.28 1.28-1.28s1.28 0.576 1.28 1.28v7.68h7.565c0.704 0 1.28 0.576 1.28 1.28s-0.576 1.28-1.28 1.28z" })]
});
export default SvgTrackTime;
